export default function TopCities(props) {
    return(
        <div>
            <p>
                Top Cities:
                {/* <TopCityResults /> */}
            </p>
        </div>
    )
}